"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const usePayModuleStyle = () => {
    const theme = (0, material_1.useTheme)();
    const container = {
        width: '390px',
        boxShadow: 'none',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: '0px',
        gap: '1rem',
        '& .titleContent': {
            width: '100%',
        },
    };
    const titleTypography = Object.assign({ color: theme.qlub.palette.onSurfaceColors.highEmphasis, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }, theme.qlub.typography.title_md);
    const actionGroup = {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        gap: '1rem',
    };
    const buttonStyle = Object.assign(Object.assign({}, theme.qlub.typography.button), { width: '139px' });
    const taxStyle = Object.assign(Object.assign({}, theme.qlub.typography.caption_overline), { color: theme.qlub.palette.onSurfaceColors.disabled, display: 'flex' });
    return {
        container,
        titleTypography,
        actionGroup,
        buttonStyle,
        taxStyle,
    };
};
exports.default = usePayModuleStyle;
